

const envs = {
    development: {
        BEDUKA_COM_TOKEN_NAME: 'ngTokenTest',
        BEDUKA_COM_USER_NAME: 'ngNameTest',
        SIMULADO_V2_URL: 'http://localhost:3000/simulados-enem/inicio',
        API_BASE_URL: 'http://localhost:3485/simulado-api', /* LOCAL */
        BEDUKA_BOLSAS_BASE_URL: 'https://beta.beduka.com/bolsas',
        FACEBOOK_APP_ID: '496706570661244', /* LOCAL */
        // ADS_BASE_URL: 'http://localhost:3000/ads', /* LOCAL */ 
        GOOGLE_APP_URL: '112320913996-bqua2n0jq9hrugutfvn5fpge9ac5qf4k.apps.googleusercontent.com', /* LOCAL */
        BEDUKA_BOLSAS_WEB_URL: 'https://beduka.com/bolsas/'
    },
    beta: {
        BEDUKA_COM_TOKEN_NAME: 'ngTokenTest',
        BEDUKA_COM_USER_NAME: 'ngNameTest',
        SIMULADO_V2_URL: 'https://beta.beduka.com/simulados-enem/inicio',
        API_BASE_URL: 'https://beta.beduka.com/simulado-api', /* BETA.BEDUKA.COM */
        FACEBOOK_APP_ID: '276155616430634', /* BETA.BEDUKA.COM */
        GOOGLE_APP_URL: '112320913996-bqua2n0jq9hrugutfvn5fpge9ac5qf4k.apps.googleusercontent.com', /* BETA.BEDUKA.COM */
        BEDUKA_BOLSAS_WEB_URL: 'https://beta.beduka.com/bolsas/'
        // ADS_BASE_URL: 'https://beta.beduka.com/ads/S2/', /* BETA.BEDUKA.COM */
    },
    production: {
        BEDUKA_COM_TOKEN_NAME: 'ngToken',
        BEDUKA_COM_USER_NAME: 'ngName',
        SIMULADO_V2_URL: 'https://beduka.com/simulados-enem/inicio',
        API_BASE_URL: 'https://beduka.com/simulado-api', /* BEDUKA.COM */
        FACEBOOK_APP_ID: '1894143960843582', /* BEDUKA.COM */
        GOOGLE_APP_URL: '112320913996-5q8u2ob6cqidtmdqjb0tq3ku5un3b3hj.apps.googleusercontent.com', /* BEDUKA.COM */
        BEDUKA_BOLSAS_WEB_URL: 'https://beduka.com/bolsas/'
        // ADS_BASE_URL: 'https://beduka.com/ads/S2/', /* BEDUKA.COM */
    }
}


export default envs[process.env.REACT_APP_ENVIRONMENT];